var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { float: "right" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.manualModal",
              modifiers: { manualModal: true }
            }
          ],
          staticClass: "button button-menu fake-button"
        },
        [
          _c("i", {
            staticClass: "fas fa-question",
            attrs: { title: "Help & Info" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "manualModal",
            title: _vm.translations.Manual,
            size: "xl"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$bvModal.hide("manualModal")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.translations.Close) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "embed-responsive",
              staticStyle: { height: "55vw" }
            },
            [
              _c("iframe", {
                staticClass: "embed-responsive-item",
                attrs: {
                  src: _vm.manualURL,
                  width: "100%",
                  height: "100%",
                  frameborder: "0",
                  allowfullscreen: ""
                }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }